import { useQuery } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import SupplierOverviewService from 'src/modules/3rd-party-management/apis/admin/SupplierOverviewService';

export const SUPPLIER_OVERVIEW_SEARCH_OVERVIEW_QUERY_KEY = '3rd-party-management-fetch-supplier-overview-search-overview';

const useSupplierOverviewSearchOverview = ({
    supplierId,
    t,
}) => {
    return useQuery({
        queryKey: [SUPPLIER_OVERVIEW_SEARCH_OVERVIEW_QUERY_KEY, supplierId],
        queryFn: async () => {
            const service = SupplierOverviewService.getInstance();

            return await service.fetchSearchOverview(supplierId);
        },
        cacheTime: 0,
        refetchOnWindowFocus: false,
        enabled: !!supplierId,
        onError: (error) => {
            if (process.env.NODE_ENV === 'development') console.error(error);

            toast(t('An error occurred while fetching search overview data.'), {
                type: 'error',
            });
        },
    });
};

export default useSupplierOverviewSearchOverview;
